export default "__VITE_ASSET__5tT4xS7U__"